import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { GetClickCampaignsReq } from './mapper/getClickCampaigns';
import { getClickCampaigns } from './mapper/getClickCampaigns';

export const clickViewingQueryKey = createQueryKeys('click', {
  campaigns: (params?: GetClickCampaignsReq) => ({
    queryFn: async () => {
      const response = await getClickCampaigns(params || {});
      return response;
    },
    queryKey: [params || {}],
  }),
});
